import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import DeleteIcon from "assets/icons/deleteClient.svg?react";
import AddButton from "components/AddButton";
import { ETabs } from "components/EditClientModalNew/typings";
import { useTranslation } from "react-i18next";

const ContactPersonsClientModal: FC<Props> = ({ view, data, setData }) => {
  const { t } = useTranslation();
  const removeAddress = (index: number) => {
    const newAddresses = data.contactPerson.filter(
      (a, aIndex: number) => index !== aIndex
    );
    setData({ ...data, contactPerson: newAddresses });
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.padding}>
        <div className={styles.list}>
          {data.contactPerson.map((a, index) => {
            return (
              <div className={styles.person}>
                <div className={styles.personWrapper}>
                  <div className={styles.line}>
                    <Input
                      label={
                        view !== ETabs.COMPANY
                          ? t("forms.companyOrInstitution")
                          : t("forms.fullName")
                      }
                      onChange={(t) => {
                        const newAddresses = [...data.contactPerson];

                        newAddresses[index].name = t;
                        setData({ ...data, contactPerson: newAddresses });
                      }}
                      value={a.name}
                    />
                    {data.contactPerson.length > 1 && (
                      <div className={styles.addWrapper}>
                        <div className={styles.add}>
                          <DeleteIcon
                            onClick={() => {
                              removeAddress(index);
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <Input
                    label={t("forms.email")}
                    onChange={(t) => {
                      const newAddresses = [...data.contactPerson];

                      newAddresses[index].email = t;
                      setData({ ...data, contactPerson: newAddresses });
                    }}
                    value={a.email}
                  />
                  <Input
                    isPhoneNumber
                    label={t("forms.phone")}
                    onChange={(t) => {
                      const newAddresses = [...data.contactPerson];

                      newAddresses[index].phone = t;
                      setData({ ...data, contactPerson: newAddresses });
                    }}
                    value={a.phone}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.btn}>
          <div className={styles.btnWrapper}>
            <AddButton
              onClick={() => {
                setData({
                  ...data,
                  contactPerson: [
                    ...data.contactPerson,
                    { email: "", name: "", phone: "" },
                  ],
                });
              }}
              text={t("common.addAnotherPerson")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPersonsClientModal;
